module.exports = __webpack_public_path__ + "img/top1.11039fad.png";